module.exports = "/_next/static/media/1e8ffd2739488621a717461cc117f4c1.png";